import { $, $$, setAttributes } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import Shower from 'modules/shower';

const accordions = $$('.accordion');

if (accordions.length) {
  accordions.forEach(accordion => {
    const randomID = uniqueId();
    const target = $('.accordion__content', accordion);
    const handler = $('.btn', accordion);

    setAttributes(handler, {
      id: `acc-btn-${randomID}`,
      'aria-controls': `acc-tab-${randomID}`,
    });

    setAttributes(target, {
      id: `acc-tab-${randomID}`,
      'aria-labelledby': `acc-btn-${randomID}`,
    });

    new Shower({
      target,
      handler,
      easing: 'easeInOutQuart',
      duration: 400,
      initOpened: false,
      openClassName: 'is-active',
    }).init();
  });
}
